export var EventItemType;
(function (EventItemType) {
    EventItemType["START"] = "EventItemType/START";
    EventItemType["END"] = "EventItemType/END";
    EventItemType["SEGMENT"] = "EventItemType/SEGMENT";
})(EventItemType || (EventItemType = {}));
export var SEGMENT_LENGTH = 14.285714285714285;
